"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoLogoutEnumArray = exports.AutoLogoutEnum = void 0;
var AutoLogoutEnum;
(function (AutoLogoutEnum) {
    AutoLogoutEnum["FIFTEEN_MINUTES"] = "FIFTEEN_MINUTES";
    AutoLogoutEnum["ONE_HOUR"] = "ONE_HOUR";
    AutoLogoutEnum["ONE_WORK_DAY"] = "ONE_WORK_DAY";
    AutoLogoutEnum["ONE_FULL_DAY"] = "ONE_FULL_DAY";
})(AutoLogoutEnum || (exports.AutoLogoutEnum = AutoLogoutEnum = {}));
exports.autoLogoutEnumArray = Object.values(AutoLogoutEnum);
